import {
  Box,
  ColumnLayout,
  Container,
  FormField,
  Header,
  RadioGroup,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { LABELS } from "./constants";
import InfoField from "../UI/InfoField";
import {
  CODE_MASTER,
  COMMON_LABELS,
  getDivisionLabel,
} from "../default-constants";
import { BankAccountsUpdateRequest } from "../../features/api-interfaces";

interface IPaymentCycle {
  paymentCycleCode?: string;
  isModalOpen: boolean;
  isUpdate: boolean;
  request: BankAccountsUpdateRequest;
  setRequest: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
}

/**
 * 入金口座情報照会・更新 支払サイクル
 */
export const PaymentCycle = (props: IPaymentCycle) => {
  const { paymentCycleCode, isModalOpen, isUpdate, request, setRequest } =
    props;
  const paymentCycleCodes = CODE_MASTER["PAYMENT_CYCLE_CODE"];
  const displayPaymentCycleCode = getDivisionLabel(
    paymentCycleCodes,
    String(paymentCycleCode ?? "")
  );

  return (
    <Container header={<Header variant={"h2"}>{LABELS.PAYMENT_CYCLE}</Header>}>
      <>
        {isUpdate ? (
          <FormField
            label={
              <SpaceBetween direction={"horizontal"} size={"xs"}>
                <Box variant={"strong"}>{LABELS.PAYMENT_CYCLE}</Box>
                <Box variant={"small"} color={"text-status-error"}>
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
            <RadioGroup
              items={paymentCycleCodes}
              onChange={({ detail: { value } }) =>
                setRequest({ ...request, paymentCycleCode: value })
              }
              value={request.paymentCycleCode}
            />
          </FormField>
        ) : (
          <>
            {isModalOpen ? (
              <SpaceBetween direction={"horizontal"} size={"l"}>
                <ColumnLayout columns={4}>
                  <InfoField
                    direction={"vertical"}
                    size={"xxs"}
                    tag={"h4"}
                    values={[LABELS.PAYMENT_CYCLE]}
                  />
                </ColumnLayout>
                <ColumnLayout columns={4}>
                  <InfoField
                    direction={"vertical"}
                    size={"xxxs"}
                    tag={"p"}
                    values={[displayPaymentCycleCode]}
                  />
                </ColumnLayout>
              </SpaceBetween>
            ) : (
              <SpaceBetween direction={"horizontal"} size={"xxl"}>
                <InfoField
                  direction={"vertical"}
                  size={"xxs"}
                  tag={"h4"}
                  values={[LABELS.PAYMENT_CYCLE]}
                />
                <InfoField
                  direction={"vertical"}
                  size={"xxs"}
                  tag={"p"}
                  values={[displayPaymentCycleCode]}
                />
              </SpaceBetween>
            )}
          </>
        )}
      </>
    </Container>
  );
};
